import { Orientations } from '@/enums/products'

export const formatGetLatestDesignResponse = (designs = []) => {
  const orientationReferences = Object.values(Orientations)

  return orientationReferences.reduce((acc, orientationReference) => {
    const designForOrientation = designs.find(design => design.productGroups.find(productGroup => productGroup.reference === orientationReference))

    if (designForOrientation) {
      return {
        ...acc,
        [orientationReference]: designForOrientation.slug
      }
    }

    return acc
  }, {})
}

export const formatGetLatestDesignResponseWithAllData = (designs = []) => {
  const orientationReferences = Object.values(Orientations)

  return orientationReferences.reduce((acc, orientationReference) => {
    const designForOrientation = designs.find(design => design.productGroups.find(productGroup => productGroup.reference === orientationReference))

    if (designForOrientation) {
      return {
        ...acc,
        [orientationReference]: designForOrientation
      }
    }

    return acc
  }, {})
}
